import type { ReportRow } from '@api/types'
import { useI18n } from '@i18n/I18nProvider'
import { directionsUrl } from '@lib/directions'
import { CONDITION_STYLES } from '@ui/ConditionBadge'
import { Icon } from '@ui/Icon'
import { Photo } from '@ui/Photo'
import { Link } from 'wouter'
import { formatDateTime } from './period'

// Un aviso en el panel: estado, árbol, municipio, cuándo, cómo y dónde; con su foto si la hay
// (enlace temporal firmado, se abre a tamaño completo).
export const ReportCard = ({
	report,
	municipality,
	linkTree = true,
}: {
	report: ReportRow
	municipality: string
	linkTree?: boolean
}) => {
	const { t, locale } = useI18n()
	const where = report.location ? directionsUrl(report.location) : null
	return (
		<article className="flex gap-4 rounded-3xl bg-white p-4 shadow-sm">
			{report.photoUrl && (
				<a href={report.photoUrl} target="_blank" rel="noopener noreferrer" className="shrink-0">
					<Photo
						src={report.photoUrl}
						alt={t('reports.photo', { code: report.treeCode })}
						className="size-24 rounded-2xl object-cover"
					/>
				</a>
			)}
			<div className="min-w-0 flex-1">
				<p className="flex items-center gap-2 font-bold">
					<span
						className={`size-3 shrink-0 rounded-full ${CONDITION_STYLES[report.condition]}`}
						aria-hidden="true"
					/>
					{t(`condition.${report.condition}`)}
				</p>
				{linkTree ? (
					<Link
						href={`/arboles/${encodeURIComponent(report.treeCode)}`}
						className="font-semibold text-forest-800 underline underline-offset-4"
					>
						{t('tree.code', { code: report.treeCode })}
					</Link>
				) : null}
				<p className="text-earth-800">{municipality}</p>
				<p className="text-sm text-earth-800">
					{formatDateTime(report.reportedAt, locale)} · {t(`reports.channel.${report.channel}`)}
				</p>
				{where ? (
					<a
						href={where}
						target="_blank"
						rel="noopener noreferrer"
						className="mt-1 inline-flex min-h-12 items-center gap-1 text-sm font-semibold text-forest-800"
					>
						<Icon name="pin" className="size-4" />
						{t('reports.location')}
					</a>
				) : (
					<p className="mt-1 text-sm text-earth-600">{t('reports.noLocation')}</p>
				)}
			</div>
		</article>
	)
}
